/**
 *
 * Input
 *
 */

import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { injectIntl } from "react-intl";

export const SMALL_FONT_SIZE = 0.8; // rem
export const SMALL_PADDING = 0.5; // rem

export const SMALL_TOP_PADDING = -10; // px
export const SMALL_TOP_NO_PADDING = -11; // px

export const NORMAL_FONT_SIZE = "inherit";
export const NORMAL_TOP_PADDING = 13; // px;
export const NORMAL_TOP_NO_PADDING = 6; // px;

const BASE_STYLE = {
  display: "inline-block",
  color: "#9f9f9f",
  backgroundColor: "#ffffff",
  pointerEvents: "none",
  position: "absolute",
  left: "11px",
  transition: "top 0.1s, font-size 0.1s, padding-left 0.1s, padding-right 0.1s",
};

function noop() {}

export class TextInput extends PureComponent {
  static propTypes = {
    noPadding: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    type: PropTypes.string,
    required: PropTypes.bool,
    variant: PropTypes.string,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    minW: PropTypes.number,
    minH: PropTypes.number,
    value: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiline: PropTypes.bool,
    rowsMax: PropTypes.number,
    fullWidth: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    keepPlaceholder: PropTypes.bool,
    focusTextField: PropTypes.bool,
    input: PropTypes.any,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    autoComplete: PropTypes.string,
  };

  static defaultProps = {
    variant: "standard",
    rowsMax: 10,
    fullWidth: true,
    keepPlaceholder: true,
    onFocus: noop,
    onBlur: noop,
    autoComplete: "on",
  };

  state = {
    placeholder: "",
    focus: false,
  };

  componentDidMount = () => {
    if (this.props.focusTextField) {
      this.handleOnFocus();
    }

    if (typeof this.props.placeholder === "object") {
      this.setState({
        placeholder: this.props.intl.formatMessage(this.props.placeholder),
      });
    }else{
      this.setState({
        placeholder:this.props.placeholder
      })
    }
  };

  buildDefaultStyle() {
    const style = { ...BASE_STYLE };

    if (this.props.noPadding) {
      style.top = `${NORMAL_TOP_NO_PADDING}px`;
      style.lineHeight = "1rem";
    } else {
      style.top = `${NORMAL_TOP_PADDING}px`;
      style.lineHeight = "1rem";
    }

    return style;
  }

  buildStyle(up = false) {
    let style = this.buildDefaultStyle();

    if (up) {
      style = this.buildUpStyle(style);
    } else {
      style = this.buildNormalStyle(style);
    }

    style.isUp = up;
    return style;
  }

  buildUpStyle(style) {
    const newStyle = {
      ...style,
      fontSize: `${SMALL_FONT_SIZE}rem`,
      paddingLeft: `${SMALL_PADDING}rem`,
      paddingRight: `${SMALL_PADDING}rem`,
    };

    if (this.props.noPadding) {
      newStyle.top = `${SMALL_TOP_NO_PADDING}px`;
    } else {
      newStyle.top = `${SMALL_TOP_PADDING}px`;
    }

    return newStyle;
  }

  buildNormalStyle(style) {
    const newStyle = { ...style, fontSize: NORMAL_FONT_SIZE };

    if (this.props.noPadding) {
      newStyle.top = `${NORMAL_TOP_NO_PADDING}px`;
    } else {
      newStyle.top = `${NORMAL_TOP_PADDING}px`;
    }

    return newStyle;
  }

  handleOnFocus = () => {
    this.setState({
      focus: true,
    });
    this.props.onFocus();
  };

  handleOnBlur = () => {
    this.setState({
      focus: false,
    });
    this.props.onBlur();
  };

  searchTimeout = -1;

  handleChange = e => {
    this.handleOnFocus();
    e.persist();
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  componentWillUnmount() {
    if (this.searchTimeout !== -1) {
      clearTimeout(this.searchTimeout);
    }
  }

  render() {
    const style = this.buildStyle(!!this.props.value || this.state.focus);

    // Delete onConfirm if present, to avoid error
    let localProps = this.props;
    if (localProps.onConfirm) {
      localProps = { ...this.props };
      delete localProps.onConfirm;
    }

    return (
      <Wrapper>
        {
          <this.props.input
            id={this.props.id}
            {...localProps}
            autoComplete={this.props.autoComplete}
            // placeholder = {this.props.placeholder}
            placeholder={
              this.props.keepPlaceholder ? "" : this.state.placeholder
            }
            onChange={this.handleChange}
            value={this.props.value}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
          />
        }
        {this.props.keepPlaceholder && (
          <StyledSpan id="placeholder-label" style={style}>
            {this.state.placeholder}
          </StyledSpan>
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
`;

const StyledSpan = styled.span`
  white-space: nowrap;
  overflow: visible;
  max-width: calc(100% - 50px);

  text-overflow: ellipsis;
`;

export default injectIntl(TextInput);
